import React, { useRef, useEffect } from 'react';

const loadImage = (src: string): Promise<HTMLImageElement> => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = 'Anonymous';
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = src;
  });
};

const lumaDarkenOnly = (bottom: number[], top: number[]) => {
  const bottomLuma = 0.299 * bottom[0] + 0.587 * bottom[1] + 0.114 * bottom[2];
  const topLuma = 0.299 * top[0] + 0.587 * top[1] + 0.114 * top[2];
  return topLuma < bottomLuma ? top : bottom;
};

const mergeImages = (canvas: HTMLCanvasElement, images: HTMLImageElement[]) => {
  const ctx = canvas.getContext('2d');
  if (!ctx || images.length === 0) return;

  const { width, height } = images[0];
  canvas.width = width;
  canvas.height = height;
  ctx.clearRect(0, 0, width, height);
  ctx.drawImage(images[0], 0, 0, width, height);
  let baseImageData = ctx.getImageData(0, 0, width, height);

  for (let i = 1; i < images.length; i++) {
    ctx.clearRect(0, 0, width, height);
    ctx.drawImage(images[i], 0, 0, width, height);
    const topImageData = ctx.getImageData(0, 0, width, height);
    const result = ctx.createImageData(width, height);

    for (let j = 0; j < baseImageData.data.length; j += 4) {
      const b = baseImageData.data.slice(j, j + 4);
      const t = topImageData.data.slice(j, j + 4);
      const [r, g, b_, a] = lumaDarkenOnly(b, t);
      result.data.set([r, g, b_, a], j);
    }
    baseImageData = result;
  }

  ctx.putImageData(baseImageData, 0, 0);
};

const RegionImageOverlay: React.FC<{ imageSources: string[], canvasClass: string }> = ({ imageSources, canvasClass }) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    if (!canvasRef.current || imageSources.length === 0) return;
    const loadAndMerge = async () => {
      const images = await Promise.all(imageSources.map(loadImage));
      mergeImages(canvasRef.current!, images);
    };
    loadAndMerge();
  }, [imageSources]);

  return <canvas ref={canvasRef} className={canvasClass} style={{ width: 300, height: 200, borderRadius: 0, background: '#eee' }} />;
};

export default RegionImageOverlay;